import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { store } from './store/rootStore';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './authConfig';

ReactDOM.render(
  // <React.StrictMode>
  //     <CustomerTab />
  //   </React.StrictMode>,
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </MsalProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
